var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNonAc = function SvgNonAc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "nonAC_svg__a",
    width: 16,
    height: 17,
    x: 0,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0-.666h16v16H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#nonAC_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nonAC_svg__b",
    width: 16,
    height: 17,
    x: 0,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0-.666h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#nonAC_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M8.335 10.417v2.916q0 .15-.092.242a.33.33 0 0 1-.242.092q-.15 0-.242-.092a.33.33 0 0 1-.091-.242v-2.9l-2.267 2.234a.35.35 0 0 1-.233.108.28.28 0 0 1-.233-.108.3.3 0 0 1-.117-.234.3.3 0 0 1 .117-.233l2.583-2.6-1.8-1.8-2.583 2.6a.3.3 0 0 1-.234.117.3.3 0 0 1-.233-.117.28.28 0 0 1-.1-.225.33.33 0 0 1 .1-.242l2.233-2.266h-2.9q-.15 0-.241-.092a.33.33 0 0 1-.092-.242q0-.15.092-.242A.33.33 0 0 1 2.001 7h2.917L1.451 3.55a.4.4 0 0 1-.091-.233q-.009-.135.108-.25a.32.32 0 0 1 .467 0L12.85 14a.3.3 0 0 1 .109.217q.009.133-.109.25a.3.3 0 0 1-.233.116.3.3 0 0 1-.233-.116zm1.8-2.75h-1.3L7.668 6.5V5.2L4.935 2.467a.3.3 0 0 1-.117-.234A.3.3 0 0 1 4.935 2q.082-.1.225-.1.142 0 .241.1l2.267 2.233v-2.9q0-.15.091-.242A.33.33 0 0 1 8.001 1q.15 0 .242.091.092.093.092.242v2.9L10.6 2a.35.35 0 0 1 .234-.109.28.28 0 0 1 .233.109.3.3 0 0 1 .117.233.3.3 0 0 1-.117.234L8.335 5.2V7h1.8l2.733-2.733a.3.3 0 0 1 .233-.117.3.3 0 0 1 .234.117q.1.083.1.224a.33.33 0 0 1-.1.242L11.1 7h2.9q.15 0 .242.091.092.093.092.242 0 .15-.092.242a.33.33 0 0 1-.242.092h-2.9l2.234 2.266q.05.051.075.108a.3.3 0 0 1 .025.126.32.32 0 0 1-.1.233.3.3 0 0 1-.234.117.3.3 0 0 1-.233-.117z"
  })))));
};
export default SvgNonAc;